import { Button, Checkbox, FormControlLabel, FormGroup, Tooltip, Switch } from '@material-ui/core';
import InfoIcon from '@mui/icons-material/Info';
import React, { useEffect, useReducer, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { activeInactiveRadioOptions } from '../../constants/HotelServicesConst';
import {
  fetchIntegrationStatus,
  integrationConfigMapsSelector,
  integrationConfigsSelector,
  integrationStatusSelector,
} from '../../layouts/configurations/configurationSlice';
import { selectedHotelSelector } from '../../layouts/property/propertySlice';
import { formDataValidate } from '../../utils/formUtils';
import { vendorConnect, vendorReset } from '../../utils/IntegrationsAPIUtils';
import { notificationManager } from '../../utils/NotificationUtils';
import CustomActiveInactiveRadio from '../form-controls/custom-active-inactive-radio/Custom-Active-Inactive-Radio';
import CustomSelect from '../form-controls/custom-select/Custom-Select';
import CustomTextField from '../form-controls/custom-text-field/Custom-Text-Field';
import './IntegrationSource.scss';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import CustomPopupModel from '../custom-popup/Custom-Popup';
import { styled } from '@mui/material/styles';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../utils/loaderSlice';

const IntegrationSource = (props) => {
  const {
    formData,
    setFormData,
    section,
    headTitle,
    allowInctive,
    onClickSync,
    checked,
    isSyncEnabled = false,
    showLoader = () => {},
  } = props;
  const integrationConfigs = useSelector(integrationConfigsSelector);
  const integrationConfigMaps = useSelector(integrationConfigMapsSelector);
  const integrationStatus = useSelector(integrationStatusSelector);
  const selectedHotel = useSelector(selectedHotelSelector);
  useEffect(() => {
    console.log('[IntegrationSource] section:', section, 'integrationConfigs:', integrationConfigs);
  }, [section, integrationConfigs]);

  const [integrationSources, setIntegrationSources] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [vendor, setVendor] = useState({});
  const [isConnected, setIsConnected] = useState(false);
  const [resetConfirm, setResetConfirm] = useState({
    status: false,
    title: '',
  });
  const dispatch = useDispatch();
  const defaultSourceCorrectedRef = useRef(false);

  useEffect(() => {
    if (selectedHotel) dispatch(fetchIntegrationStatus(selectedHotel));
  }, [selectedHotel]);
  const normalizeKey = (s) =>
    (s || '')
      ?.toString()
      ?.trim()
      ?.replace(/\s+/g, '')
      ?.replace(/[-_]/g, '')
      ?.replace(/s$/i, '')
      ?.toUpperCase();

  const SECTION_ALIAS = {
    PAYMENT: 'PAYMENTS',
    PAYMENTS: 'PAYMENTS',
    PM: 'PAYMENTS',
    LOYALTY: 'LOYALTY',
    REWARDSANDLOYALTY: 'LOYALTY',

    CRS: 'CRS',
    ROOMRESERVATION: 'CRS',
    ROOMRESERVATIONS: 'CRS',
    ROOM_RESERVATION: 'CRS',
    CENTRALRESERVATIONSYSTEM: 'CRS',
    CENTRALRESERVATION: 'CRS',

    EREG: 'EREG',
    DIGITALCHECKIN: 'EREG',
    DIGITAL_CHECKIN: 'EREG',
    CHECKIN: 'EREG',
    E_REG: 'EREG',
    EREGISTRATION: 'EREG',

    DDL: 'DDL',
    DIGITALCHECKOUT: 'DDL',
    DIGITAL_CHECKOUT: 'DDL',
    CHECKOUT: 'DDL',

    HK: 'HK',
    HOUSEKEEPING: 'HK',
    HOUSE_KEEPING: 'HK',

    GRMS: 'GRMS',
    GUESTROOMMANAGEMENTSYSTEM: 'GRMS',

    TS: 'TS',
    TELEPHONY: 'TS',
    TELECOM: 'TS',
    TRAVELSERVICE: 'TS',
    TRAVELSERVICES: 'TS',

    KYCDOC: 'KYCDOC',
    DOCUMENTVERIFICATION: 'KYCDOC',
    DOCUMENTSCAN: 'KYCDOC',
    DOCUMENT_SCAN: 'KYCDOC',
    DOCSCAN: 'KYCDOC',

    RRS: 'RRS',
    RESTAURANTRESERVATION: 'RRS',
    RESTAURANT_RESERVATION: 'RRS',
    TABLERESERVATION: 'RRS',
    TABLE_RESERVATION: 'RRS',

    DINING: 'DINING',
    RESTAURANT: 'DINING',
    IRD: 'DINING',
    INROOMDINING: 'DINING',
    IN_ROOM_DINING: 'DINING',

    SPA: 'SPA',
    SPARESERVATION: 'SPA',
    SPA_RESERVATION: 'SPA',

    EVENTHUB: 'EVENTHUB',
    ANALYTICS: 'ANALYTICS',
    GOOGLEANALYTICS: 'ANALYTICS',
    GOOGLE_ANALYTICS: 'ANALYTICS',
    TPNS: 'TPNS',
    THIRDPARTYNOTIFICATIONSERVICE: 'TPNS',
    THIRDPARTYNOTIFICATIONSYSTEM: 'TPNS',
    THIRDPARTYNOTIFICATIONSYTEM: 'TPNS',
    CHAT: 'CHAT',
    WEATHER: 'WEATHER',
  };
  const resolveSection = (s) => {
    const k = normalizeKey(s);
    return SECTION_ALIAS[k] || SECTION_ALIAS[`${k}S`] || k;
  };
  const sameSection = (a, b) => resolveSection(a) === resolveSection(b);
  const cap = (t) => (t ? t.charAt(0).toUpperCase() + t.slice(1).toLowerCase() : t);
  const getMapForSource = (key) => {
    if (!key || !integrationConfigMaps) return null;
    const candidates = [key, key.toUpperCase?.(), key.toLowerCase?.(), cap(key)].filter(Boolean);
    for (const k of candidates) {
      if (k && integrationConfigMaps[k]) return integrationConfigMaps[k];
    }
    return null;
  };

  const initialFormData = {
    hostingType: {
      value: false,
      fieldName: 'On-Prem Hosting',
      errors: {},
      validations: [],
    },
  };

  const [connectFormData, setConnectFormData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    initialFormData,
  );

  const CustomSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: '#03E67C',
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#03E67C',
    },
  }));

  useEffect(() => {
    if (section && integrationConfigs && integrationConfigs.length > 0) {
      const config = integrationConfigs.find((c) => sameSection(c.name, section));
      if (config) {
        const srcs = (config.sources || []).map((s) => ({ id: s, name: s }));
        setIntegrationSources(srcs);
        let connectedSource = null;
        if (integrationStatus && config.sources?.length > 0) {
          for (const src of config.sources) {
            const st = integrationStatus?.[src] || integrationStatus?.[src?.toUpperCase?.()];
            if (st?.status === 'connected' && st?.platform) {
              connectedSource = src;
              break;
            }
          }
        }

        if (!formData?.integrationSource?.value && config.sources?.length > 0) {
          const defaultSource = config.sources.find((s) => s?.toUpperCase?.() === 'PMS') || config.sources[0];
          setFormData({
            integrationSource: {
              ...(formData.integrationSource || {}),
              value: connectedSource || defaultSource,
              fieldName: 'Integration Source',
              errors: {},
              validations: [],
            },
          });
        }

        if (allowInctive && config.sources?.length > 0) {
          const defaultSource = config.sources.find((s) => s?.toUpperCase?.() === 'PMS') || config.sources[0];
          setFormData({
            integrationSource: {
              ...(formData.integrationSource || {}),
              value: connectedSource || defaultSource,
              fieldName: 'Integration Source',
              errors: {},
              validations: [],
            },
          });
        }
      } else {
        setIntegrationSources([]);
      }
    }
  }, [integrationConfigs, section, integrationStatus]);

  const shouldIgnoreSectionFallback = (sectionFallbackKey, testSourceKey = formData?.integrationSource?.value) => {
    if (!testSourceKey || !sectionFallbackKey || !integrationSources) return false;
    const candNorm = resolveSection(sectionFallbackKey);
    return integrationSources.some(s => {
      const sKey = resolveSection(s.id);
      return sKey === candNorm && sKey !== resolveSection(testSourceKey);
    });
  };

  useEffect(() => {
    if (!section || !integrationSources?.length) return;
    const sectionKey = resolveSection(section);
    const rawBySection = integrationStatus?.[sectionKey] || integrationStatus?.[`${sectionKey}S`];
    const shouldIgnore = shouldIgnoreSectionFallback(sectionKey);
    const bySection = (rawBySection?.status === 'connected' && !shouldIgnore) ? rawBySection : null;
    const rawBySource = formData?.integrationSource?.value
      ? integrationStatus?.[formData?.integrationSource?.value]
      : null;
    const bySource = rawBySource?.status === 'connected' ? rawBySource : null;
    const statusObj = bySource || bySection;
    if (statusObj?.status === 'connected' && statusObj?.platform) {
      const srcKey = formData?.integrationSource?.value;
      const map = srcKey ? (getMapForSource(srcKey) || []) : [];
      let vendorKindToSelect = null;
      if (map.some((v) => v.kind === statusObj.platform)) {
        vendorKindToSelect = statusObj.platform;
      } else if (map.length > 0) {
        vendorKindToSelect = map[0].kind;
      }
      if (vendorKindToSelect && formData?.integrationSourceSelected?.value !== vendorKindToSelect) {
        setFormData({
          integrationSourceSelected: {
            ...(formData.integrationSourceSelected || {}),
            value: vendorKindToSelect,
            fieldName: 'Vendor',
            errors: {},
            validations: [],
          },
        });
      }
    }
  }, [integrationStatus, integrationSources, section, formData?.integrationSource?.value]);

  useEffect(() => {
    const key = formData?.integrationSource?.value;
    if (!key) {
      setVendor({});
      setVendorOptions([]);
      return;
    }
    const map = getMapForSource(key);
    if (map && Array.isArray(map)) {
      const options = map.map((v) => ({ id: v.kind, name: v.name }));
      setVendor({});
      setVendorOptions(options);
      if (!formData?.integrationSourceSelected?.value && options.length === 1) {
        setFormData({
          integrationSourceSelected: {
            ...(formData.integrationSourceSelected || {}),
            value: options[0].id,
            fieldName: 'Vendor',
            errors: {},
            validations: [],
          },
        });
      }
    } else {
      setVendor({});
      setVendorOptions([]);
    }
  }, [formData.integrationSource?.value, integrationConfigMaps]);

  useEffect(() => {
    const sourceKey = formData?.integrationSource?.value;
    if (!sourceKey) {
      setIsConnected(false);
      setVendor(null);
      return;
    }
    const map = getMapForSource(sourceKey) || [];
    if (map.length === 0) {
      setIsConnected(false);
      setVendor(null);
      return;
    }
    if (formData?.integrationSourceSelected?.value) {
      const selectedKind = formData.integrationSourceSelected.value;
      const currVendor = map.find((s) => s.kind === selectedKind);
      if (!currVendor) {
        setFormData({
          integrationSourceSelected: {
            ...(formData.integrationSourceSelected || {}),
            value: '',
            fieldName: 'Vendor',
            errors: {},
            validations: [],
          },
        });
        setIsConnected(false);
        setVendor(null);
        return;
      }
      const sectionKey = resolveSection(section);
      const rawBySection = integrationStatus?.[sectionKey] || integrationStatus?.[`${sectionKey}S`];
      const shouldIgnore = shouldIgnoreSectionFallback(sectionKey, sourceKey);
      const bySection = !shouldIgnore ? rawBySection : null;
      const bySource = integrationStatus?.[sourceKey];
      const strictMatch =
        (bySection && bySection.platform === selectedKind ? bySection : null) ||
        (bySource && bySource.platform === selectedKind ? bySource : null);
      const fallbackMatch = !strictMatch
        ? ((bySection?.status === 'connected' && bySection?.platform &&
            !map.some((v) => v.kind === bySection.platform) ? bySection : null) ||
           (bySource?.status === 'connected' && bySource?.platform &&
            !map.some((v) => v.kind === bySource.platform) ? bySource : null))
        : null;
      const currentStatus = strictMatch || fallbackMatch;
      let currConnectMetaData = null;
      if (currentStatus && currentStatus.status === 'connected') {
        try {
          currConnectMetaData = currentStatus.metaData ? JSON.parse(currentStatus.metaData) : null;
        } catch {
          currConnectMetaData = null;
        }
        setIsConnected(true);
      } else {
        setIsConnected(false);
      }
      if (Array.isArray(currVendor.inputs) && currVendor.inputs.length > 0) {
        const currFormData = {
          ...initialFormData,
          hostingType: { ...initialFormData.hostingType },
        };
        currVendor.inputs.forEach((v) => {
          if (v.kind === 'TEXT') {
            currFormData[v.key] = {
              value:
                v.key === 'hotelId'
                  ? selectedHotel
                  : currConnectMetaData && currConnectMetaData[v.key]
                  ? currConnectMetaData[v.key]
                  : '',
              fieldName: v.name,
              errors: {},
              validations: v.required ? ['required'] : [],
            };
          }
        });
        if (currConnectMetaData) {
          currFormData.hostingType.value = currConnectMetaData.hostingType === 'true';
        }
        setConnectFormData(currFormData);
        setVendor(currVendor);
      } else {
        setVendor(null);
      }
    } else {
      let connectedPlatform = null;
      let connectedFallbackKind = null;
      if (integrationStatus && map.length > 0) {
        const sectionKey = resolveSection(section);
        const candidates = [...new Set(
          [sourceKey, sourceKey?.toUpperCase?.(), sourceKey?.toLowerCase?.(),
           sectionKey, `${sectionKey}S`]
            .filter(Boolean)
        )].filter(cand => !shouldIgnoreSectionFallback(cand, sourceKey));
        for (const ck of candidates) {
          const st = integrationStatus[ck];
          if (st?.status === 'connected' && st?.platform) {
            if (map.some((v) => v.kind === st.platform)) {
              connectedPlatform = st.platform;
              break;
            }
            if (!connectedFallbackKind && map.length > 0) {
              connectedFallbackKind = map[0].kind;
            }
          }
        }
      }
      const vendorToSelect = connectedPlatform || connectedFallbackKind;
      if (vendorToSelect) {
        setFormData({
          integrationSourceSelected: {
            ...(formData.integrationSourceSelected || {}),
            value: vendorToSelect,
            fieldName: 'Vendor',
            errors: {},
            validations: [],
          },
        });
      } else {
        setIsConnected(false);
        setVendor(null);
      }
    }
  }, [
    formData?.integrationSourceSelected?.value,
    formData?.integrationSource?.value,
    integrationConfigMaps,
    integrationStatus,
    selectedHotel,
    integrationSources,
    section,
  ]);

  const validateConnect = () => {
    const updatedFields = {};
    const currTabFromData = Object.fromEntries(
      Object.entries(connectFormData).filter(([key]) => vendor?.inputs?.some((v) => v.key === key)),
    );
    const isValid = formDataValidate(currTabFromData, updatedFields);
    setConnectFormData(updatedFields);
    return isValid;
  };

  const handleConnect = async (e) => {
    e.preventDefault();
    if (validateConnect() && vendor?.connect?.query && vendor?.connect?.variables) {
      try {
        dispatch(stepUpLoaderCount());
        const variables = Object.keys(vendor.connect.variables).reduce((obj, curr) => {
          if (connectFormData[curr]) obj[curr] = connectFormData[curr]?.value;
          return obj;
        }, {});
        const connectResult = await vendorConnect(vendor.connect.query, variables, vendor.baseUrl);
        console.log('[IntegrationSource] Connect - result:', JSON.stringify(connectResult?.data));
        setIsConnected(true);
        dispatch(fetchIntegrationStatus(selectedHotel));
        notificationManager('success', 'Connected successfully!');
      } catch (err) {
        const msg =
          err?.graphQLErrors?.[0]?.message ||
          err?.message ||
          'Unable to connect. Please check credentials.';
        notificationManager('danger', msg);
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
  };

  const uniq = (arr) => Array.from(new Set(arr.filter(Boolean)));

  const buildResetCandidates = (sourceKey, sectionKey) => {
    const raw = [sourceKey, sectionKey];
    const canon = raw?.map((k) => (k ? resolveSection(k) : k));
    const flip = (k) => {
      if (!k) return null;
      const u = String(k)?.toUpperCase();
      return /S$/.test(u) ? u.slice(0, -1) : u + 'S';
    };
    const toggled = [...raw, ...canon]?.map(flip);
    const statusKeys = new Set(Object.keys(integrationStatus || {}));
    const candidates = uniq([...raw, ...canon, ...toggled]);
    
    const validCandidates = candidates.filter(cand => {
      if (!sourceKey || !cand || !integrationSources) return true;
      const candNorm = resolveSection(cand);
      const isSibling = integrationSources.some(s => {
        const sKey = resolveSection(s.id);
        return sKey === candNorm && sKey !== resolveSection(sourceKey);
      });
      return !isSibling;
    });

    const present = validCandidates?.filter((k) => statusKeys?.has(k));
    const rest = validCandidates?.filter((k) => !statusKeys?.has(k));
    return uniq([...present, ...rest]);
  };
  const isRetryableResetError = (err) => {
    const msg = err?.graphQLErrors?.[0]?.message || err?.message || '';
    return /unsupported integration type/i.test(msg) || /integration details not found/i.test(msg);
  };

  const handleReset = async () => {
    dispatch(stepUpLoaderCount());
    const sourceKey = formData?.integrationSource?.value;
    const sectionKey = section;
    const candidates = buildResetCandidates(sourceKey, sectionKey);
    let lastErr = null;
    for (const key of candidates) {
      try {
        await vendorReset(selectedHotel, key);
        dispatch(fetchIntegrationStatus(selectedHotel));
        notificationManager('Success', 'Reset successfully!');
        dispatch(stepDownLoaderCount());
        handleClose();
        return;
      } catch (err) {
        lastErr = err;
        if (!isRetryableResetError(err)) break;
      }
    }
    const msg =
      lastErr?.graphQLErrors?.[0]?.message ||
      lastErr?.message ||
      'Unable to reset. Please try again.';
    notificationManager('danger', msg);
    dispatch(stepDownLoaderCount());
    handleClose();
  };
  const handleChange = (e, field) => {
    const currField = { ...connectFormData[field] };
    currField.value = e.target.checked;
    setConnectFormData({ [field]: currField });
  };

  const handleClose = () => {
    setResetConfirm({
      id: '',
      name: '',
      title: '',
      status: false,
      brand: null,
    });
  };

  const handleDeletePopupOpen = () => {
    handleClose();
    const currVal = {
      title: 'Are you sure you want to',
      name: 'Reset this configuration',
      status: true,
      buttonName: 'Yes',
      cancel: 'No',
    };
    setResetConfirm(currVal);
  };

  return (
    <div className='hotel-service-section'>
      {resetConfirm.status && (
        <CustomPopupModel popUp={resetConfirm} onClick={handleReset} onClickCancel={handleClose} />
      )}
      <div className='hotel-service-subtitle'>{headTitle}</div>
      {allowInctive ? (
        <CustomActiveInactiveRadio
          item={formData.activeInactive}
          handleRadioButton={(e) => {
            setFormData({ activeInactive: e });
          }}
          options={activeInactiveRadioOptions}
        />
      ) : (
        integrationSources &&
        integrationSources.length > 0 && (
          <CustomActiveInactiveRadio
            item={formData.integrationSource}
            handleRadioButton={(e) => {
              setFormData({ integrationSource: e });
            }}
            options={integrationSources}
          />
        )
      )}

      {(!allowInctive || formData?.activeInactive?.value === 'Active') && (
        <>
          {vendorOptions && vendorOptions.length > 0 && (
            <div className='d-flex mb-3'>
              <CustomSelect
                labelPrefix={'Select'}
                item={formData.integrationSourceSelected}
                handleInputChange={(e) => {
                  setFormData({ integrationSourceSelected: e });
                }}
                options={vendorOptions}
                className='w-25'
              />
            </div>
          )}
          {vendor && vendor.inputs && vendor.inputs.length > 0 && (
            <div>
              <div className='hotel-service-subtitle'>
                API Integration
                <span className='ms-4 '>
                  <Tooltip
                    title='Before connect, make sure these IPs are whitelisted. 3.93.139.220, 3.93.243.176 & 106.51.77.122'
                    placement='right'
                  >
                    <InfoIcon fontSize='small' className='ms-2 info-tooltip' />
                  </Tooltip>
                </span>
              </div>
              <div className='mt-2'>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        className='check-box'
                        checked={connectFormData?.hostingType?.value || false}
                        onChange={(e) => handleChange(e, 'hostingType')}
                      />
                    }
                    label={connectFormData?.hostingType?.fieldName || 'On-Prem Hosting'}
                  />
                </FormGroup>
              </div>
              <div className='row w-75 ms-2'>
                {vendor.inputs.map(
                  (field, index) =>
                    field.kind === 'TEXT' &&
                    connectFormData[field.key] && (
                      <CustomTextField
                        key={index}
                        item={connectFormData[field.key]}
                        handleInputChange={(e) => {
                          setConnectFormData({ [field.key]: e });
                        }}
                        className='col-md-6 pe-4 mb-2'
                        disabled={field.key === 'hotelId'}
                      />
                    ),
                )}
              </div>

              <div className='mt-3'>
                {isConnected ? (
                  <>
                    <Button variant='contained' type='button' color='primary' size='large'>
                      Connected
                    </Button>
                    <Button
                      variant='outlined'
                      type='button'
                      color='inherit'
                      size='large'
                      className='ms-5 btn-reset'
                      onClick={handleDeletePopupOpen}
                      startIcon={<RestartAltIcon />}
                    >
                      Reset
                    </Button>
                  </>
                ) : (
                  <Button
                    variant='outlined'
                    className='btn-connect'
                    type='button'
                    color='primary'
                    size='large'
                    onClick={handleConnect}
                  >
                    Connect
                  </Button>
                )}
              </div>
            </div>
          )}
        </>
      )}

      {isSyncEnabled && (
        <div className='mt-4'>
          <div className='hotel-service-subtitle'>Sync Settings</div>
          <div className='mt-2'>
            <span className='pe-4 '>Enable Sync:</span>
            <CustomSwitch checked={checked} onChange={onClickSync} />
          </div>
        </div>
      )}
    </div>
  );
};

export default IntegrationSource;
